import { render } from "./AssignRiderComponent.vue?vue&type=template&id=5b885f69&scoped=true"
import script from "./AssignRiderComponent.vue?vue&type=script&lang=js"
export * from "./AssignRiderComponent.vue?vue&type=script&lang=js"

import "./AssignRiderComponent.vue?vue&type=style&index=0&id=5b885f69&lang=scss&scoped=true"

import exportComponent from "/var/www/nexgen/apps/admin/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b885f69"]])

export default __exports__